<!-- ── Breadcrumb ─────────────────────────────────────────────────────────── -->
<div class="container-fluid user-task-board">

     <div class="row">
          <div class="col-md-12">
               <div class="breadcrumb-title mb-3 mt-1">
                    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">

                         <!-- Board title -->
                         <div class="d-flex align-items-center gap-2">
                              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                                   xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0">
                                   <rect x="2" y="2" width="9" height="14" rx="2" fill="#0052CC" />
                                   <rect x="13" y="2" width="9" height="9" rx="2" fill="#0052CC" />
                              </svg>
                              <p class="mb-0 fw-semibold">Task Board</p>
                              <span class="text-muted" style="font-size:0.85rem">— shared tasks for your
                                   organization</span>
                         </div>

                         <!-- Add Column button -->
                         <button mat-raised-button color="primary" (click)="toggleAddColumn()"
                              class="add-column-trigger-btn">
                              <mat-icon style="font-size:18px;width:18px;height:18px">view_column</mat-icon>
                              <span class="ms-1">{{ isAddingColumn ? 'Cancel' : 'Add Column' }}</span>
                         </button>

                    </div>
               </div>
          </div>
     </div>

     <!-- ── Add Column inline form ────────────────────────────────────────────── -->
     <div *ngIf="isAddingColumn" class="add-column-form mb-3">
          <div class="add-column-card">
               <div class="row g-2 align-items-start">
                    <div class="col-sm-7 col-md-8">
                         <input type="text" class="form-control new-column-input" [(ngModel)]="newColumnTitle"
                              placeholder="Enter column name…" maxlength="50" (keyup.enter)="addColumn()"
                              (keyup.escape)="toggleAddColumn()" />
                         <div *ngIf="addColumnError" class="add-column-error mt-1">

                              {{ addColumnError }}
                         </div>
                    </div>
                    <div class="col-sm-5 col-md-4">
                         <div class="d-flex gap-2">
                              <button mat-raised-button color="primary" (click)="addColumn()" class="flex-fill">
                                   <mat-icon style="font-size:16px;width:16px;height:16px">add</mat-icon>
                                   Add
                              </button>
                              <button mat-stroked-button (click)="toggleAddColumn()" class="flex-fill">
                                   <mat-icon style="font-size:16px;width:16px;height:16px">close</mat-icon>
                                   Cancel
                              </button>
                         </div>
                    </div>
               </div>
          </div>
     </div>

     <!-- ── Loading indicator ─────────────────────────────────────────────────── -->
     <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
               <span class="visually-hidden">Loading…</span>
          </div>
          <p class="mt-2 text-muted">Loading your tasks…</p>
     </div>

     <!-- ── Error message ─────────────────────────────────────────────────────── -->
     <div *ngIf="!isLoading && errorMessage" class="alert alert-danger mx-2">
          <mat-icon style="vertical-align:middle">error_outline</mat-icon>
          {{ errorMessage }}
     </div>

     <!-- ── Kanban Board (always shown after load, even if empty) ─────────────── -->
     <div *ngIf="!isLoading" class="board-scroll-wrapper">
          <div class="board-columns" cdkDropListGroup>

               <div *ngFor="let column of columns" class="kanban-column">

                    <!-- Column header -->
                    <div class="column-header" [style.border-top-color]="column.color">
                         <div class="d-flex align-items-center gap-2">
                              <mat-icon [style.color]="column.color" style="font-size:20px;width:20px;height:20px">
                                   {{ column.icon }}
                              </mat-icon>
                              <span class="column-title">{{ column.title }}</span>
                              <span class="task-count-badge ms-auto" [style.background]="column.color">
                                   {{ column.tasks.length }}
                              </span>
                              <!-- Column actions menu -->
                              <button class="col-menu-btn" [matMenuTriggerFor]="colMenu"
                                   (click)="$event.stopPropagation()" aria-label="Column options"
                                   matTooltip="Column options">
                                   <mat-icon style="font-size:18px;width:18px;height:18px">more_vert</mat-icon>
                              </button>
                              <mat-menu #colMenu="matMenu">
                                   <button mat-menu-item (click)="openEditColumnModal(column, $event)">
                                        <mat-icon color="primary"
                                             style="font-size:18px;width:18px;height:18px">edit</mat-icon>
                                        <span>Edit Column</span>
                                   </button>
                                   <button mat-menu-item (click)="openDeleteColumnModal(column, $event)">
                                        <mat-icon color="warn"
                                             style="font-size:18px;width:18px;height:18px">delete</mat-icon>
                                        <span>Delete Column</span>
                                   </button>
                              </mat-menu>
                         </div>
                    </div>

                    <!-- ── Drop zone ───────────────────────────────────────────────────── -->
                    <div class="task-list" [id]="column.id" cdkDropList [cdkDropListData]="column.tasks"
                         [cdkDropListConnectedTo]="columnIds" (cdkDropListDropped)="drop($event, column.id)">

                         <!-- Task cards -->
                         <div *ngFor="let task of column.tasks" class="task-card" cdkDrag [cdkDragData]="task"
                              role="button" tabindex="0" (click)="openTaskDetail(task)"
                              (keyup.enter)="openTaskDetail(task)">

                              <!-- CDK drag placeholder -->
                              <div class="task-card-placeholder" *cdkDragPlaceholder></div>

                              <!-- CDK drag preview -->
                              <div class="task-card-preview" *cdkDragPreview>
                                   <div class="priority-stripe" [style.background]="getPriorityColor(task.priority)">
                                   </div>
                                   <div class="task-card-body">
                                        <p class="task-title mb-0">{{ task.title }}</p>
                                   </div>
                              </div>

                              <!-- Priority stripe -->
                              <div class="priority-stripe" [style.background]="getPriorityColor(task.priority)"></div>

                              <div class="task-card-body">

                                   <!-- Card action buttons (edit / delete) -->
                                   <div class="task-card-actions">
                                        <button class="task-action-btn task-action-btn--edit"
                                             (click)="openEditModal(task, column.id, $event)" matTooltip="Edit task"
                                             aria-label="Edit task">
                                             <mat-icon style="font-size:14px;width:14px;height:14px">edit</mat-icon>
                                        </button>
                                        <button class="task-action-btn task-action-btn--delete"
                                             (click)="openDeleteModal(task.id, column.id, $event)"
                                             matTooltip="Delete task" aria-label="Delete task">
                                             <mat-icon style="font-size:14px;width:14px;height:14px">delete</mat-icon>
                                        </button>
                                   </div>

                                   <!-- Title -->
                                   <p class="task-title mb-1">{{ task.title }}</p>

                                   <!-- Description (truncated) -->
                                   <!-- <p *ngIf="task.description" class="task-desc mb-2 text-muted">
                                        {{ task.description | slice:0:80 }}{{ task.description.length > 80 ? '…' : '' }}
                                   </p> -->

                                   <!-- Labels -->
                                   <!-- <div *ngIf="task.labels && task.labels.length > 0" class="task-labels mb-2">
                                        <span *ngFor="let label of task.labels" class="task-label-chip">{{ label
                                             }}</span>
                                   </div> -->

                                   <!-- Footer row -->
                                   <div
                                        class="d-flex align-items-center justify-content-between flex-wrap gap-1 mt-auto">

                                        <!-- Priority badge -->
                                        <!-- <span class="priority-badge"
                                             [style.background]="getPriorityColor(task.priority) + '22'"
                                             [style.color]="getPriorityColor(task.priority)"
                                             [style.border-color]="getPriorityColor(task.priority) + '55'">
                                             {{ getPriorityLabel(task.priority) }}
                                        </span> -->

                                        <!-- Due date -->
                                        <span *ngIf="task.dueDate" class="due-date-chip"
                                             [class.overdue]="isOverdue(task.dueDate)">
                                             <mat-icon
                                                  style="font-size:12px;width:12px;height:12px">calendar_today</mat-icon>
                                             {{ formatDate(task.dueDate) }}
                                        </span>

                                   </div>

                                   <!-- People row (Assignee + Members) -->
                                   <div class="card-people-row">
                                        <!-- Assignee -->
                                        <div *ngIf="task.assignee" class="assignee-avatar" [matTooltip]="task.assignee">
                                             {{ getInitials(task.assignee) }}
                                        </div>

                                        <!-- Member avatars (stacked) -->
                                        <div class="members-stack">
                                             <div *ngFor="let member of task.members | slice:0:3"
                                                  class="member-avatar-sm" [style.background]="getMemberColor(member)"
                                                  [matTooltip]="member">
                                                  {{ getInitials(member) }}
                                             </div>
                                             <div *ngIf="task.members && task.members.length > 3"
                                                  class="member-overflow-badge"
                                                  [matTooltip]="task.members.slice(3).join(', ')">
                                                  +{{ task.members.length - 3 }}
                                             </div>
                                        </div>
                                   </div>

                              </div>
                         </div>

                         <!-- Column empty state -->
                         <div *ngIf="column.tasks.length === 0" class="column-empty">
                              <mat-icon style="opacity:0.25;font-size:36px;width:36px;height:36px">
                                   {{ column.icon }}
                              </mat-icon>
                              <p class="text-muted mt-2" style="font-size:0.78rem">Drop tasks here</p>
                         </div>

                    </div>

                    <!-- ── Add Task button (bottom of each column) ──────────────── -->
                    <div class="column-add-task">
                         <button class="add-task-btn" (click)="openCreateModal(column.id)">
                              <mat-icon style="font-size:16px;width:16px;height:16px">add</mat-icon>
                              Add Task
                         </button>
                    </div>

               </div>

          </div>
     </div>

</div>
<!-- ── Create Task Modal ───────────────────────────────────────────────────── -->
<div *ngIf="showCreateModal" class="task-modal-backdrop" (click)="closeCreateModal()">
     <div class="task-modal create-modal" (click)="$event.stopPropagation()">

          <div class="task-modal-header" [style.border-top-color]="getCreateColumnColor()">
               <div class="d-flex align-items-center gap-2">
                    <mat-icon [style.color]="getCreateColumnColor()"
                         style="font-size:20px;width:20px;height:20px">add_task</mat-icon>
                    <h5 class="mb-0">Add Task — {{ getCreateColumnTitle() }}</h5>
               </div>
               <button mat-icon-button (click)="closeCreateModal()" aria-label="Close">
                    <mat-icon>close</mat-icon>
               </button>
          </div>

          <div class="task-modal-body">

               <!-- Error -->
               <div *ngIf="saveError" class="alert alert-danger py-2 mb-3" style="font-size:0.85rem">
                    <mat-icon
                         style="vertical-align:middle;font-size:16px;width:16px;height:16px">error_outline</mat-icon>
                    {{ saveError }}
               </div>

               <!-- Title -->
               <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Task Title *</mat-label>
                    <input matInput [(ngModel)]="newTask.title" placeholder="Enter task title" maxlength="200" />
               </mat-form-field>

               <!-- Description -->
               <mat-form-field appearance="outline" class="w-100 mt-3" subscriptSizing="dynamic">
                    <mat-label>Description</mat-label>
                    <textarea matInput [(ngModel)]="newTask.description" placeholder="Describe the task…" rows="3"
                         maxlength="2000"></textarea>
               </mat-form-field>

               <!-- Priority + Due Date row -->
               <div class="row mt-3 g-2">
                    <div class="col-6">
                         <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                              <mat-label>Priority</mat-label>
                              <mat-select [(ngModel)]="newTask.priority">
                                   <mat-option *ngFor="let p of priorityOptions" [value]="p">
                                        <span class="priority-dot" [style.background]="getPriorityColor(p)"></span>
                                        {{ getPriorityLabel(p) }}
                                   </mat-option>
                              </mat-select>
                         </mat-form-field>
                    </div>
                    <div class="col-6">
                         <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                              <mat-label>Due Date</mat-label>
                              <input matInput type="date" [(ngModel)]="newTask.targetDate" />
                         </mat-form-field>
                    </div>
               </div>

               <!-- Column indicator -->
               <div class="d-flex align-items-center gap-2 mt-3 px-1 column-indicator">
                    <span class="column-indicator-dot" [style.background]="getCreateColumnColor()"></span>
                    <span>Will be added to <strong>{{ getCreateColumnTitle() }}</strong></span>
               </div>

          </div>

          <div class="task-modal-footer">
               <button mat-stroked-button (click)="closeCreateModal()" [disabled]="isSaving">
                    Cancel
               </button>
               <button mat-flat-button color="primary" (click)="saveNewTask()"
                    [disabled]="isSaving || !newTask.title.trim()">
                    <mat-icon *ngIf="isSaving" class="spin"
                         style="font-size:16px;width:16px;height:16px">refresh</mat-icon>
                    {{ isSaving ? 'Creating…' : 'Create Task' }}
               </button>
          </div>

     </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!-- ── Edit Task Modal ─────────────────────────────────────────────────────── -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showEditModal && editingTask" class="task-modal-backdrop" (click)="closeEditModal()">
     <div class="task-modal create-modal" (click)="$event.stopPropagation()">

          <div class="task-modal-header" [style.border-top-color]="getPriorityColor(editingTask.priority)">
               <div class="d-flex align-items-center gap-2">
                    <mat-icon style="font-size:20px;width:20px;height:20px;color:#0052CC">edit</mat-icon>
                    <h5 class="mb-0">Edit Task</h5>
               </div>
               <button mat-icon-button (click)="closeEditModal()" aria-label="Close">
                    <mat-icon>close</mat-icon>
               </button>
          </div>

          <div class="task-modal-body">

               <!-- Error -->
               <div *ngIf="editSaveError" class="alert alert-danger py-2 mb-3" style="font-size:0.85rem">
                    <mat-icon
                         style="vertical-align:middle;font-size:16px;width:16px;height:16px">error_outline</mat-icon>
                    {{ editSaveError }}
               </div>

               <!-- Title -->
               <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Task Title *</mat-label>
                    <input matInput [(ngModel)]="editForm.title" placeholder="Enter task title" maxlength="200" />
               </mat-form-field>

               <!-- Description -->
               <mat-form-field appearance="outline" class="w-100 mt-3" subscriptSizing="dynamic">
                    <mat-label>Description</mat-label>
                    <textarea matInput [(ngModel)]="editForm.description" placeholder="Describe the task…" rows="3"
                         maxlength="2000"></textarea>
               </mat-form-field>

               <!-- Priority + Due Date row -->
               <div class="row mt-3 g-2">
                    <div class="col-6">
                         <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                              <mat-label>Priority</mat-label>
                              <mat-select [(ngModel)]="editForm.priority">
                                   <mat-option *ngFor="let p of priorityOptions" [value]="p">
                                        <span class="priority-dot" [style.background]="getPriorityColor(p)"></span>
                                        {{ getPriorityLabel(p) }}
                                   </mat-option>
                              </mat-select>
                         </mat-form-field>
                    </div>
                    <div class="col-6">
                         <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                              <mat-label>Due Date</mat-label>
                              <input matInput type="date" [(ngModel)]="editForm.targetDate" />
                         </mat-form-field>
                    </div>
               </div>

               <!-- Assignee -->
               <mat-form-field appearance="outline" class="w-100 mt-3" subscriptSizing="dynamic">
                    <mat-label>Assign To</mat-label>
                    <mat-select [(ngModel)]="editForm.assignee">
                         <mat-option value="">— Unassigned —</mat-option>
                         <mat-option *ngFor="let user of appUsers" [value]="user.displayName">
                              {{ user.displayName }}
                              <span *ngIf="user.email" class="text-muted ms-1" style="font-size:0.78rem">({{ user.email
                                   }})</span>
                         </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="isLoadingUsers">Loading team members…</mat-hint>
               </mat-form-field>

          </div>

          <div class="task-modal-footer">
               <button mat-stroked-button (click)="closeEditModal()" [disabled]="isEditSaving">
                    Cancel
               </button>
               <button mat-flat-button color="primary" (click)="saveEditedTask()"
                    [disabled]="isEditSaving || !editForm.title.trim()">
                    <mat-icon *ngIf="isEditSaving" class="spin"
                         style="font-size:16px;width:16px;height:16px">refresh</mat-icon>
                    {{ isEditSaving ? 'Saving…' : 'Save Changes' }}
               </button>
          </div>

     </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!-- ── Delete Confirmation Modal ───────────────────────────────────────────── -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showDeleteModal" class="task-modal-backdrop" (click)="closeDeleteModal()">
     <div class="task-modal delete-confirm-modal" (click)="$event.stopPropagation()">

          <div class="task-modal-header" style="border-top-color:#dc3545; background:#fff5f5;">
               <div class="d-flex align-items-center gap-2">
                    <mat-icon style="font-size:20px;width:20px;height:20px;color:#dc3545">delete_forever</mat-icon>
                    <h5 class="mb-0">Delete Task</h5>
               </div>
               <button mat-icon-button (click)="closeDeleteModal()" aria-label="Close">
                    <mat-icon>close</mat-icon>
               </button>
          </div>

          <div class="task-modal-body">
               <p class="text-secondary mb-0" style="font-size:0.93rem">
                    Are you sure you want to delete this task? This action cannot be undone.
               </p>
          </div>

          <div class="task-modal-footer">
               <button mat-stroked-button (click)="closeDeleteModal()" [disabled]="isDeleting">
                    Cancel
               </button>
               <button mat-raised-button color="warn" (click)="confirmDelete()" [disabled]="isDeleting">
                    <mat-icon *ngIf="isDeleting" class="spin"
                         style="font-size:16px;width:16px;height:16px">refresh</mat-icon>
                    <mat-icon *ngIf="!isDeleting" style="font-size:16px;width:16px;height:16px">delete</mat-icon>
                    {{ isDeleting ? 'Deleting…' : 'Delete' }}
               </button>
          </div>

     </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!-- ── Edit Column Modal ───────────────────────────────────────────────────── -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showEditColumnModal && editingColumn" class="task-modal-backdrop" (click)="closeEditColumnModal()">
     <div class="task-modal delete-confirm-modal" (click)="$event.stopPropagation()">

          <div class="task-modal-header" [style.border-top-color]="editingColumn.color">
               <div class="d-flex align-items-center gap-2">
                    <mat-icon [style.color]="editingColumn.color"
                         style="font-size:20px;width:20px;height:20px">edit</mat-icon>
                    <h5 class="mb-0">Edit Column</h5>
               </div>
               <button mat-icon-button (click)="closeEditColumnModal()" aria-label="Close">
                    <mat-icon>close</mat-icon>
               </button>
          </div>

          <div class="task-modal-body">
               <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Column Name *</mat-label>
                    <input matInput [(ngModel)]="editColumnTitle" placeholder="Enter column name" maxlength="50"
                         (keyup.enter)="saveEditedColumn()" />
               </mat-form-field>
               <div *ngIf="editColumnError" class="text-danger mt-1" style="font-size:0.78rem">
                    {{ editColumnError }}
               </div>
          </div>

          <div class="task-modal-footer">
               <button mat-stroked-button (click)="closeEditColumnModal()">Cancel</button>
               <button mat-flat-button color="primary" (click)="saveEditedColumn()"
                    [disabled]="!editColumnTitle.trim()">
                    Save
               </button>
          </div>

     </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!-- ── Delete Column Confirmation Modal ────────────────────────────────────── -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showDeleteColumnModal && deletingColumn" class="task-modal-backdrop" (click)="closeDeleteColumnModal()">
     <div class="task-modal delete-confirm-modal" (click)="$event.stopPropagation()">

          <div class="task-modal-header" style="border-top-color:#dc3545; background:#fff5f5;">
               <div class="d-flex align-items-center gap-2">
                    <mat-icon style="font-size:20px;width:20px;height:20px;color:#dc3545">delete_forever</mat-icon>
                    <h5 class="mb-0">Delete Column</h5>
               </div>
               <button mat-icon-button (click)="closeDeleteColumnModal()" aria-label="Close">
                    <mat-icon>close</mat-icon>
               </button>
          </div>

          <div class="task-modal-body">
               <p class="text-secondary mb-0" style="font-size:0.93rem">
                    <ng-container *ngIf="deletingColumn.tasks.length > 0">
                         This column contains <strong>{{ deletingColumn.tasks.length }} task(s)</strong>. All tasks
                         will also be permanently deleted. Continue?
                    </ng-container>
                    <ng-container *ngIf="deletingColumn.tasks.length === 0">
                         Are you sure you want to delete the <strong>{{ deletingColumn.title }}</strong> column? This
                         action cannot be undone.
                    </ng-container>
               </p>
          </div>

          <div class="task-modal-footer">
               <button mat-stroked-button (click)="closeDeleteColumnModal()" [disabled]="isDeletingColumn">
                    Cancel
               </button>
               <button mat-raised-button color="warn" (click)="confirmDeleteColumn()" [disabled]="isDeletingColumn">
                    <mat-icon *ngIf="isDeletingColumn" class="spin"
                         style="font-size:16px;width:16px;height:16px">refresh</mat-icon>
                    <mat-icon *ngIf="!isDeletingColumn" style="font-size:16px;width:16px;height:16px">delete</mat-icon>
                    {{ isDeletingColumn ? 'Deleting…' : 'Delete Column' }}
               </button>
          </div>

     </div>
</div>
<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="selectedTask" class="task-modal-backdrop" (click)="closeTaskDetail()">
     <div class="task-modal task-detail-modal" (click)="$event.stopPropagation()">

          <!-- Header -->
          <div class="task-modal-header" [style.border-top-color]="getPriorityColor(selectedTask.priority)">
               <h5 class="mb-0">{{ selectedTask.title }}</h5>
               <button mat-icon-button (click)="closeTaskDetail()" aria-label="Close">
                    <mat-icon>close</mat-icon>
               </button>
          </div>

          <!-- Two-panel body -->
          <div class="task-detail-panels">

               <!-- LEFT: task details -->
               <div class="task-detail-left">
                    <div class="task-modal-body">

                         <p *ngIf="selectedTask.description" class="task-modal-desc">{{ selectedTask.description }}</p>
                         <p *ngIf="!selectedTask.description" class="text-muted" style="font-size:0.85rem">No
                              description provided.</p>

                         <div class="task-detail-grid">

                              <!-- <div class="task-modal-row">
                                   <span class="task-modal-label">Status</span>
                                   <span class="status-chip" [ngClass]="getStatusClass(selectedTask.status)">{{
                                        selectedTask.status }}</span>
                              </div> -->

                              <div class="task-modal-row">
                                   <span class="task-modal-label">Priority</span>
                                   <span class="priority-badge"
                                        [style.background]="getPriorityColor(selectedTask.priority) + '22'"
                                        [style.color]="getPriorityColor(selectedTask.priority)"
                                        [style.border-color]="getPriorityColor(selectedTask.priority) + '55'">
                                        {{ getPriorityLabel(selectedTask.priority) }}
                                   </span>
                              </div>

                              <div class="task-modal-row" *ngIf="selectedTask.assignee">
                                   <span class="task-modal-label">Assigned To</span>
                                   <div class="d-flex align-items-center gap-2">
                                        <div class="assignee-avatar sm">{{ getInitials(selectedTask.assignee) }}</div>
                                        <span>{{ selectedTask.assignee }}</span>
                                   </div>
                              </div>

                              <!-- <div class="task-modal-row" *ngIf="selectedTask.createdBy">
                                   <span class="task-modal-label">Created By</span>
                                   <span>{{ selectedTask.createdBy }}</span>
                              </div> -->

                              <!-- <div class="task-modal-row" *ngIf="selectedTask.dueDate">
                                   <span class="task-modal-label">Due Date</span>
                                   <span [class.overdue-text]="isOverdue(selectedTask.dueDate)">
                                        {{ formatDate(selectedTask.dueDate) }}
                                   </span>
                              </div> -->

                              <!-- <div class="task-modal-row" *ngIf="selectedTask.labels && selectedTask.labels.length > 0">
                                   <span class="task-modal-label">Labels</span>
                                   <div class="task-labels">
                                        <span *ngFor="let label of selectedTask.labels" class="task-label-chip">{{ label
                                             }}</span>
                                   </div>
                              </div> -->

                              <!-- <div class="task-modal-row" *ngIf="selectedTask.createdAt">
                                   <span class="task-modal-label">Created</span>
                                   <span class="text-muted" style="font-size:0.82rem">
                                        {{ selectedTask.createdAt | date:'mediumDate' }}
                                   </span>
                              </div> -->

                              <!-- ── Action Buttons Row (Trello-style) ─────────── -->
                              <div class="task-modal-row border-bottom pb-2 mb-2">
                                   <div class="d-flex flex-wrap gap-2">

                                        <!-- Add / Member picker -->
                                        <div class="position-relative">
                                             <button
                                                  class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                                                  (click)="toggleMemberPicker()" [disabled]="isUpdatingMember">
                                                  <mat-icon
                                                       style="font-size:14px;width:14px;height:14px">person_add</mat-icon>
                                                  Add
                                             </button>
                                             <div *ngIf="showMemberPicker" class="member-picker"
                                                  (click)="$event.stopPropagation()">
                                                  <input type="text" class="form-control form-control-sm mb-1"
                                                       [(ngModel)]="memberSearchQuery" placeholder="Search users…"
                                                       autofocus />
                                                  <div *ngIf="availableUsersToAdd.length === 0"
                                                       class="text-muted small px-1">No users available</div>
                                                  <div *ngFor="let user of availableUsersToAdd"
                                                       class="member-picker-item" (click)="addMember(user)">
                                                       <div class="member-avatar-sm"
                                                            [style.background]="getMemberColor(user.displayName)">
                                                            {{ getInitials(user.displayName) }}
                                                       </div>
                                                       <span>{{ user.displayName }}</span>
                                                       <span class="text-muted ms-1" style="font-size:0.7rem">{{
                                                            user.email }}</span>
                                                       <mat-icon class="member-picker-add-icon">add_circle</mat-icon>
                                                  </div>
                                             </div>
                                        </div>

                                        <button class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                                             (click)="toggleChecklistPanel()">
                                             <mat-icon
                                                  style="font-size:14px;width:14px;height:14px">check_box</mat-icon>
                                             Checklist
                                        </button>

                                        <!-- <button class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                                             disabled>
                                             <mat-icon style="font-size:14px;width:14px;height:14px">label</mat-icon>
                                             Labels
                                        </button> -->

                                        <!-- <button class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                                             disabled>
                                             <mat-icon style="font-size:14px;width:14px;height:14px">event</mat-icon>
                                             Dates
                                        </button> -->

                                        <!-- <button class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                                             disabled>
                                             <mat-icon
                                                  style="font-size:14px;width:14px;height:14px">attach_file</mat-icon>
                                             Attachment
                                        </button> -->

                                   </div>
                              </div>

                              <!-- ── Members: stacked avatars + count ───────────── -->
                              <div class="task-modal-row members-row"
                                   *ngIf="(selectedTask.members && selectedTask.members.length > 0) || memberError">
                                   <span class="task-modal-label">Members</span>
                                   <div class="members-stack">
                                        <div *ngFor="let member of (selectedTask.members | slice:0:4)"
                                             class="member-avatar-sm" [style.background]="getMemberColor(member)"
                                             [matTooltip]="member" style="cursor:pointer">
                                             {{ getInitials(member) }}
                                        </div>
                                        <div *ngIf="selectedTask.members && selectedTask.members.length > 4"
                                             class="member-overflow-badge"
                                             [matTooltip]="selectedTask.members.slice(4).join(', ')">
                                             +{{ selectedTask.members.length - 4 }}
                                        </div>
                                   </div>
                                   <div *ngIf="memberError" class="text-danger small w-100">{{ memberError }}</div>
                              </div>

                              <!-- ── Checklist Section ───────────────────────────── -->
                              <div *ngIf="showChecklistPanel && selectedTask" class="mt-3 p-3 border rounded bg-light">

                                   <!-- Header -->
                                   <div class="d-flex align-items-center gap-2 mb-2">
                                        <mat-icon
                                             style="font-size:16px;width:16px;height:16px;color:#555">check_box</mat-icon>
                                        <span class="fw-semibold flex-grow-1" style="font-size:0.88rem">Checklist</span>
                                        <span class="text-muted small">{{ getCheckedCount() }}/{{ checklists.length
                                             }}</span>
                                   </div>

                                   <!-- Progress bar -->
                                   <div *ngIf="checklists.length > 0" class="d-flex align-items-center gap-2 mb-3">
                                        <div class="progress flex-grow-1" style="height:6px">
                                             <div class="progress-bar"
                                                  [class.bg-success]="getChecklistProgress() === 100"
                                                  [style.width]="getChecklistProgress() + '%'">
                                             </div>
                                        </div>
                                        <span class="text-muted small fw-semibold">{{ getChecklistProgress() }}%</span>
                                   </div>

                                   <!-- Items -->
                                   <div class="d-flex flex-column gap-1 mb-2">
                                        <div *ngFor="let item of checklists; let i = index"
                                             class="checklist-item d-flex align-items-center gap-2 rounded px-2 py-1">

                                             <input type="checkbox" class="form-check-input mt-0 flex-shrink-0"
                                                  [checked]="item.checked" (change)="toggleChecklistItem(i)" />

                                             <!-- Display mode -->
                                             <span *ngIf="editingChecklistIndex !== i"
                                                  class="flex-grow-1 small checklist-item-done"
                                                  [class.text-decoration-line-through]="item.checked"
                                                  [class.text-muted]="item.checked" (dblclick)="startEditChecklist(i)">
                                                  {{ item.text }}
                                             </span>

                                             <!-- Edit mode -->
                                             <input *ngIf="editingChecklistIndex === i"
                                                  class="form-control form-control-sm flex-grow-1"
                                                  [(ngModel)]="editingChecklistText"
                                                  (keydown.enter)="saveChecklistEdit(i)"
                                                  (keydown.escape)="cancelChecklistEdit()"
                                                  (click)="$event.stopPropagation()" autofocus />

                                             <div class="checklist-item-actions d-flex gap-1">
                                                  <button *ngIf="editingChecklistIndex === i"
                                                       class="btn btn-sm btn-outline-success p-0 px-1"
                                                       (click)="saveChecklistEdit(i)">
                                                       <mat-icon
                                                            style="font-size:13px;width:13px;height:13px">check</mat-icon>
                                                  </button>
                                                  <button *ngIf="editingChecklistIndex === i"
                                                       class="btn btn-sm btn-outline-secondary p-0 px-1"
                                                       (click)="cancelChecklistEdit()">
                                                       <mat-icon
                                                            style="font-size:13px;width:13px;height:13px">close</mat-icon>
                                                  </button>
                                                  <button *ngIf="editingChecklistIndex !== i"
                                                       class="btn btn-sm btn-outline-secondary p-0 px-1"
                                                       (click)="startEditChecklist(i)" matTooltip="Edit">
                                                       <mat-icon
                                                            style="font-size:13px;width:13px;height:13px">edit</mat-icon>
                                                  </button>
                                                  <button class="btn btn-sm btn-outline-danger p-0 px-1"
                                                       (click)="deleteChecklistItem(i)" matTooltip="Delete">
                                                       <mat-icon
                                                            style="font-size:13px;width:13px;height:13px">delete_outline</mat-icon>
                                                  </button>
                                             </div>

                                        </div>
                                   </div>

                                   <!-- Add item input -->
                                   <div *ngIf="showAddChecklistInput" class="d-flex flex-column gap-2">
                                        <input class="form-control form-control-sm" [(ngModel)]="newChecklistItemText"
                                             placeholder="Add an item…" (keydown.enter)="addChecklistItem()"
                                             (keydown.escape)="cancelAddChecklist()" (click)="$event.stopPropagation()"
                                             autofocus />
                                        <div class="d-flex gap-2">
                                             <button mat-flat-button color="primary" (click)="addChecklistItem()"
                                                  [disabled]="!newChecklistItemText.trim()">
                                                  Add
                                             </button>
                                             <button mat-button (click)="cancelAddChecklist()">Cancel</button>
                                        </div>
                                   </div>

                                   <button *ngIf="!showAddChecklistInput"
                                        class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1 mt-1"
                                        (click)="openAddChecklistInput()">
                                        <mat-icon style="font-size:14px;width:14px;height:14px">add</mat-icon>
                                        Add an item
                                   </button>

                              </div>

                         </div>
                    </div>
               </div>

               <!-- RIGHT: Comments panel (Trello-style) -->
               <div class="task-comments-panel">

                    <div class="comments-panel-header">
                         <mat-icon style="font-size:18px;width:18px;height:18px;color:#555">comment</mat-icon>
                         <span>Comments and activity</span>
                         <span class="comments-count-badge" *ngIf="taskComments.length > 0">{{ taskComments.length
                              }}</span>
                    </div>

                    <!-- Write a comment -->
                    <div class="comment-input-row">
                         <div class="comment-author-avatar"
                              [style.background]="getMemberColor(currentUserName || currentUserEmail || 'U')">
                              {{ getInitials(currentUserName || currentUserEmail || 'U') }}
                         </div>
                         <div class="comment-input-wrap">
                              <textarea class="comment-textarea" [(ngModel)]="newCommentText"
                                   placeholder="Write a comment…" rows="2" (keydown.control.enter)="addComment()">
                              </textarea>
                              <div class="comment-input-actions" *ngIf="newCommentText.trim()">
                                   <button mat-flat-button color="primary" class="comment-save-btn"
                                        (click)="addComment()" [disabled]="isSavingComment">
                                        <mat-icon *ngIf="isSavingComment" class="spin"
                                             style="font-size:14px;width:14px;height:14px">refresh</mat-icon>
                                        {{ isSavingComment ? 'Saving…' : 'Save' }}
                                   </button>
                                   <button mat-button class="comment-cancel-btn"
                                        (click)="newCommentText = ''">Discard</button>
                              </div>
                              <div *ngIf="commentError" class="text-danger mt-1" style="font-size:0.75rem">{{
                                   commentError }}</div>
                         </div>
                    </div>

                    <!-- Comment list -->
                    <div class="comments-list-area">

                         <div *ngIf="isLoadingComments" class="comments-loading">
                              <div class="spinner-border spinner-border-sm text-secondary"></div>
                              <span>Loading…</span>
                         </div>

                         <div *ngIf="!isLoadingComments && taskComments.length === 0" class="comments-empty">
                              <mat-icon
                                   style="font-size:32px;width:32px;height:32px;opacity:0.2">chat_bubble_outline</mat-icon>
                              <p class="text-muted mt-1" style="font-size:0.8rem">No comments yet</p>
                         </div>

                         <div *ngFor="let c of taskComments" class="comment-item">
                              <div class="comment-avatar" [style.background]="getMemberColor(c.authorName)">
                                   {{ getInitials(c.authorName) }}
                              </div>
                              <div class="comment-body">
                                   <div class="comment-meta">
                                        <span class="comment-author">{{ c.authorName }}</span>
                                        <span class="comment-date">{{ formatCommentDate(c.createdAt) }}</span>
                                        <span *ngIf="c.isEdited" class="text-muted ms-1"
                                             style="font-size:0.72rem;font-style:italic">edited</span>
                                        <!-- Edit button - using existing task-action-btn class -->
                                        <button
                                             *ngIf="c.authorEmail === currentUserEmail || c.authorName === currentUserName"
                                             class="task-action-btn task-action-btn--edit" (click)="startEditComment(c)"
                                             matTooltip="Edit comment">
                                             <mat-icon style="font-size:14px;width:14px;height:14px">edit</mat-icon>
                                        </button>
                                        <!-- Delete button - using existing task-action-btn class -->
                                        <button
                                             *ngIf="c.authorEmail === currentUserEmail || c.authorName === currentUserName"
                                             class="task-action-btn task-action-btn--delete"
                                             (click)="deleteComment(c.id)" matTooltip="Delete comment">
                                             <mat-icon
                                                  style="font-size:14px;width:14px;height:14px">delete_outline</mat-icon>
                                        </button>
                                   </div>

                                   <!-- Comment text - show edit mode or display mode -->
                                   <div *ngIf="editingCommentId !== c.id" class="comment-text">{{ c.comment }}</div>

                                   <!-- Edit mode - using existing task-modal classes -->
                                   <div *ngIf="editingCommentId === c.id" style="margin-top: 4px;">
                                        <textarea
                                             style="width:100%;border:1px solid #0052CC;border-radius:8px;padding:8px 10px;font-size:0.84rem;resize:vertical;background:var(--bs-body-bg,#fff);color:var(--bs-body-color,#333);outline:none;min-height:50px;font-family:inherit;"
                                             [(ngModel)]="editCommentText" rows="2"
                                             (keydown.control.enter)="saveEditedComment()"
                                             (keyup.escape)="cancelEditComment()"></textarea>
                                        <div style="display:flex;align-items:center;gap:8px;margin-top:6px;">
                                             <button mat-flat-button color="primary" class="comment-save-btn"
                                                  (click)="saveEditedComment()"
                                                  [disabled]="isSavingCommentEdit || !editCommentText.trim()"
                                                  style="font-size:0.8rem;height:30px;line-height:30px;display:flex;align-items:center;gap:4px;padding:0 14px;">
                                                  <mat-icon *ngIf="isSavingCommentEdit" class="spin"
                                                       style="font-size:14px;width:14px;height:14px">refresh</mat-icon>
                                                  {{ isSavingCommentEdit ? 'Saving…' : 'Save' }}
                                             </button>
                                             <button mat-button class="comment-cancel-btn" (click)="cancelEditComment()"
                                                  style="font-size:0.8rem;height:30px;color:var(--bs-secondary-color,#666);">
                                                  Cancel
                                             </button>
                                        </div>
                                        <div *ngIf="commentEditError" class="text-danger mt-1"
                                             style="font-size:0.75rem">
                                             {{ commentEditError }}
                                        </div>
                                   </div>
                              </div>
                         </div>

                    </div>
               </div>

          </div>
          <!-- end two-panel body -->

     </div>
</div>